import { IFieldTabEditor, IFillInSpacesItemEditor, IQuestionEditorState } from "app_components/modules/academicComponentEditor/containers/academicComponentEditorFunctions"
import shortId from 'shortid';
import striptags from 'striptags'

interface IOptionSelect{
  label: string
  value: string
}

interface IConfigGetPossibleLaunchConfig{
  optionsAcademicComponents?: IOptionSelect[]
}

export const getPossibleLaunchConfigFields = (options: any, launchConfig?: any, defaultModules?: any[], _config?: IConfigGetPossibleLaunchConfig ) => {
  let items: IFieldTabEditor[] = []
  let defaultModulesArray: any[] = []
  let launchConfigAux: any = {}
  if(options === undefined) return items
  // Configurar módulos por defecto
  if(defaultModules){
    defaultModulesArray = Object.keys(defaultModules)
  }
  // Configurar launch config
  if(launchConfig){
    if(launchConfig && launchConfig.length){
      launchConfigAux = (launchConfig as string[]).reduce((acum: any, item) => {
        // @ts-ignore
        acum[item] = true
        return acum
      },{})
    }else if(launchConfig && launchConfig.length === undefined) {
      launchConfigAux = launchConfig
    }
  }
  const newItems = Object.keys(options).reduce((acum: IFieldTabEditor[], item) => {
    if(options[item] === true){
      const type = item.replace('has_', '')
      let aux: IFieldTabEditor = {
        // @ts-ignore
        type: type,
        value: launchConfigAux[type],
        required: false
      }
      // Verificar el modulo por defecto
      if(defaultModulesArray.length){
        if(
          (launchConfigAux[type] === undefined ||
          launchConfigAux[type] === null) &&
          defaultModulesArray.includes(type) &&
          defaultModules
        ){
          // @ts-ignore
          aux.value = defaultModules[type]
        }
      }
      // Excepciones
      if(type === 'game'){
        aux.required = true
      }

      // @INFO Si tiene la opción de campos relacionados organizo las opciones y el valor por defecto
      if(type === 'components_related'){
        if(_config?.optionsAcademicComponents?.length){
          aux.options = [..._config.optionsAcademicComponents]
          if((aux.value as string[])?.length){
            const newValue = (aux.value as string[]).reduce((accum: IOptionSelect[], itemValue) => {
              const element = (aux.options as IOptionSelect[])?.find(item => item.value === itemValue)
              if(element){
                accum.push({
                  label: element.label,
                  value: element.value
                })
              }
              return accum
            }, [])
            aux.value = [...newValue]
          }
        }
      }

      if(type !== 'navigation'){
        acum.push({...aux})
      }

    }
    return acum
  }, [])

  // Guardar los items
  items = [...items, ...newItems]

  return items
}

/**
 * @INFO Copiar información de objeto sin referencia
 * @param data
 */
export const copyObjectEditor = (data: any) => {
  return JSON.parse(JSON.stringify(data))
}

/**
 * @INFO Obtener el texto en un ejercicio de tipo rellenar espacios
 * @param question
 */
export const getTextTinyFillInSpaces = (question: IQuestionEditorState) => {
  let response: IQuestionEditorState = {...question}
  if(response.question.answers && response.question.answers.length){
    const answer = {...response.question.answers[0]}
    if(answer.config && answer.config.fill_in_spaces && answer.config.fill_in_spaces.length){
      for(let i=0; i< answer.config.fill_in_spaces.length; i++){
        answer.content = answer.content.replace(`[${answer.config.fill_in_spaces[i].slug}]`, `[${answer.config.fill_in_spaces[i].label}]`)
      }
    }
    response.question.answers[0] = {...answer}
  }
  return response
}

/**
 * @INFO Obtener la pregunta actualizada con el cambio del tiny en rellenar espacios
 * @param question
 * @param content
 */
export const getQuestionFromChangeTinyFillInSpaces = (question: IQuestionEditorState, content: string) => {
  const textContent = striptags(content)
  const aux: IQuestionEditorState = copyObjectEditor(question)
  let fillItems: IFillInSpacesItemEditor[] = []
  let vectorItems: IFillInSpacesItemEditor[] = []
  if(
    question.question.answers &&
    question.question.answers[0].config?.fill_in_spaces?.length
  ){
    vectorItems = copyObjectEditor(question.question.answers[0].config?.fill_in_spaces)
  }
  // Encontrar palabras
  const regExpBrackets = new RegExp(/\[(\w+|\s*)+\]/gi)
  const regExpReplaceBracket = new RegExp(/(\[|\])/gi)
  const labelsBracket = textContent.match(regExpBrackets)
  if(labelsBracket?.length){
    fillItems = labelsBracket.reduce((accum: IFillInSpacesItemEditor[], item: any) => {
      accum.push({
        label: item.replace(regExpReplaceBracket, ''),
        slug: shortId.generate(),
        value: 0
      })
      return accum
    },[])
  }

  // @INFO Guardar los señuelos
  fillItems = vectorItems.reduce((accum: IFillInSpacesItemEditor[], item) => {
    if(item.is_trick){
      accum.push({...item})
    }
    return accum
  }, [...fillItems])

  // Comparar con los items de la pregunta y reemplazar los existentes
  if(aux.question.answers[0].config?.fill_in_spaces?.length){
    for(let i=0; i< aux.question.answers[0].config?.fill_in_spaces?.length; i++){
      if(fillItems[i]){
        const exist = vectorItems.reduce((acum: {fill: IFillInSpacesItemEditor , idx: number} | undefined, itemFill, idx) => {
          if(!acum && fillItems[i].label === itemFill.label){
            acum = {fill: itemFill, idx}
          }
          return acum
        }, undefined)
        if(exist !== undefined){
          fillItems[i].value = exist.fill.value
          vectorItems.splice(exist.idx, 1)
        }
      }
    }
  }
  // Guardar items en la pregunta
  if(aux.question.answers[0].config ){
    aux.question.answers[0].config.fill_in_spaces = fillItems
  }
  return aux
}

/**
 * @INFO Obtener el texto con los slug reemplazados
 * @param question
 */
export const getContentFromSendFillInSpaces = (question: IQuestionEditorState) => {
  let response: string = ''
  const aux: IQuestionEditorState = copyObjectEditor(question)
  const vectorAux = aux.question.answers[0].content.split(' ')
  let vectorItems: IFillInSpacesItemEditor[] = []
  if(
    aux.question.answers[0].config?.fill_in_spaces &&
    aux.question.answers[0].config.fill_in_spaces.length
  ){
    vectorItems = copyObjectEditor(aux.question.answers[0].config.fill_in_spaces)
  }
  if(vectorAux && vectorAux.length){
    console.log('Vector de palabras: ', vectorAux);
    vectorAux.forEach(itemText => {
      console.log(vectorItems);
      if(
        vectorItems &&
        vectorItems.length
      ){
        const responseFind = vectorItems.reduce((acum: {fill: IFillInSpacesItemEditor, idx: number} | undefined, itemFill, idx) => {
          if(!acum && itemText.includes(`[${itemFill.label}]`)){
            acum = {fill: itemFill, idx}
          }
          return acum
        }, undefined)
        if(responseFind !== undefined){
          response = `${response} ${itemText.replace(`[${responseFind.fill.label}]`, `[${responseFind.fill.slug}]`)}`
          vectorItems.splice(responseFind.idx, 1)
        }else{
          response = `${response} ${itemText}`
        }
      }else{
        response = `${response} ${itemText}`
      }
    })
  }
  console.log('Items fill in spaces: ', response);
  return response
}

interface IParamsDrawLine{
  line: string,
  pointA: string,
  pointB: string,
  color?: string
}

/**
 * @INFO Dibujar una linea entre dos elementos
 * @param params
 */
export const drawLineBetweenTwoElements = (params: IParamsDrawLine) => {
  const line = document.getElementById(params.line)
  const pointA = document.getElementById(params.pointA)
  const pointB = document.getElementById(params.pointB)
  if(pointA && pointB && line){
    const x1 = pointA.offsetLeft + (pointA.clientWidth)+4;
    const y1 = pointA.offsetTop + (pointA.clientHeight/2)+2;
    const x2 = pointB.offsetLeft;
    const y2 = pointB.offsetTop + (pointB.clientHeight/2)+2;
    line.setAttribute('x1', x1.toString())
    line.setAttribute('y1', y1.toString())
    line.setAttribute('x2', x2.toString())
    line.setAttribute('y2', y2.toString())
    if(params.color){
      line.setAttribute('stroke', params.color)
    }else{
      line.setAttribute('stroke', 'black')
    }
  }
}

/**
 * @INFO Obtener un color aleatorio RGB
 */
export const getRandomRGBColor = () => {
  const r = Math.round(Math.random()*255)
  const g = Math.round(Math.random()*255)
  const b = Math.round(Math.random()*255)
  return `rgb(${r}, ${g}, ${b})`
}

/**
 * @INFO Dibujar circulo para hacer el hover y el onClick en el circulo
 * @param id
 */
export const drawCircleRelateItems = (id: string) => {
  const circle = document.getElementById(`circle-${id}`)
  const ref = document.getElementById(id)
  if(circle && ref){
    const x = ref.offsetLeft + (ref.clientWidth/2)
    const y = ref.offsetTop + (ref.clientHeight/2)
    circle.setAttribute('cx', x.toString())
    circle.setAttribute('cy', y.toString())
    circle.setAttribute('r', ((ref.clientWidth/2)+2).toString())
  }
}
